import { Navigate, Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";
import { useWorkspaceStore } from "@web/stores";

type RouteStatus = "loading" | "has_workspaces" | "no_workspaces";

export function WorkspaceRoute() {
  const location = useLocation();
  const {
    workspaces,
    fetchWorkspaces,
    fetchLastVisit,
    lastVisitWorkspaceId,
    workspacesStatus,
  } = useWorkspaceStore();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      setIsInitialized(false);
      await fetchWorkspaces();
      await fetchLastVisit();
      if (!cancelled) {
        setIsInitialized(true);
      }
    };

    void init();

    return () => {
      cancelled = true;
    };
  }, [fetchWorkspaces, fetchLastVisit]);

  const routeStatus: RouteStatus = !isInitialized
    ? "loading"
    : workspacesStatus === "success"
      ? workspaces.length > 0
        ? "has_workspaces"
        : "no_workspaces"
      : "no_workspaces";

  // 로딩 중
  if (routeStatus === "loading") {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-muted-foreground">로딩 중...</p>
      </div>
    );
  }

  // "/" 경로에서 리다이렉트 처리
  if (location.pathname === "/") {
    // 워크스페이스가 없으면 /workspace/empty로
    if (routeStatus === "no_workspaces") {
      return <Navigate to="/workspace/empty" replace />;
    }

    // 워크스페이스가 있으면 마지막 방문 또는 첫 번째 워크스페이스로
    if (routeStatus === "has_workspaces") {
      const targetWorkspaceId = lastVisitWorkspaceId ?? workspaces[0]?.id;
      if (targetWorkspaceId) {
        return <Navigate to={`/workspace/${targetWorkspaceId}`} replace />;
      }
    }
  }

  return <Outlet />;
}
